import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Button from "../ui/Button";
import State, { STATE, AppContextState, CurrentEntityState } from "@state";
import EntityController from "@controllers/entity.controller";
import AuthController from "@controllers/auth.controller";
import { navigateTo } from "@services/navigation.service.js";
import NotificationController from "@/network/controllers/notification.controller";
import { useSession } from "@/hooks/useSession";

export default function Sidebar({ activeLink }) {
  const [currentActive, setCurrentActive] = useState(activeLink);
  const [entities, setEntities] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const { user } = useSession();
  const [unreadCount, setUnreadCount] = useState(0);

  const roleContext = AppContextState.ROLE_CONTEXT;
  const roleContextCRO = AppContextState.ROLE_CONTEXT_CRO;
  const roleContextInvestigator = AppContextState.ROLE_CONTEXT_INVESTIGATOR;

  const isInvestigator = STATE[roleContext] === roleContextInvestigator;
  const isCRO = STATE[roleContext] === roleContextCRO;

  useEffect(() => {
    console.log("🔔 unreadCount:", unreadCount);
    const fetchUnreadCount = async () => {
      const response = await NotificationController.getUserNotifications(
        user?.userId
      );
      if (response?.success && Array.isArray(response.data)) {
        const count = response.data.filter(
          (n) => n.notification_status === "pending"
        ).length;
        setUnreadCount(count);
      } else {
        console.error(
          "Erreur fetching notifications for badge:",
          response?.message || response
        );
      }
    };

    if (user?.userId) {
      fetchUnreadCount();
    }
  }, [user?.userId]);

  useEffect(() => {
    const onStateChange = (newValue, oldValue) => {
      setRefresh((v) => v + 1);
      console.log("=== oldValue === Sidebar.jsx === key: 740537 ===");
      console.dir(oldValue, { depth: null, colors: true });
      console.dir(newValue, { depth: null, colors: true });
      console.log("=================================");
    };
    State.registerListener(CurrentEntityState.CURRENT_ENTITY_ID, onStateChange);
    //State.registerListener(CurrentEntityState.CURRENT_ENTITY_DATA, onStateChange);
    return () => {
      State.unregisterListener(
        CurrentEntityState.CURRENT_ENTITY_ID,
        onStateChange
      );
      // State.unregisterListener(CurrentEntityState.CURRENT_ENTITY_DATA, onStateChange);
    };
  }, []);

  useEffect(() => {
    /** ------------------ cmt 788322 ------------------
    console.log('=== STATE === Sidebar.jsx === key: 335877 ===');
    console.dir(STATE, { depth: null, colors: true })
    console.log('=================================');
    *-------------------------------------------------*/
  }, [STATE]);

  // Fetch entities when CRO
  useEffect(() => {
    console.log('=== STATE === Sidebar.jsx === key: 784562 ===');
    console.dir(STATE, { depth: null, colors: true })
    console.log('=================================');
    console.log(
      "=== STATE[CurrentEntityState.CURRENT_ENTITY_ID] === Sidebar.jsx === key: 839838 ==="
    );
    console.dir(STATE[CurrentEntityState.CURRENT_ENTITY_ID], {
      depth: null,
      colors: true,
    });
    console.log("=================================");
    if (!isCRO) return;
    const loadEntities = async () => {
      const res = await EntityController.fetchUserEntities();
      console.log("=== res === Sidebar.jsx === key: 448045 ===");
      console.dir(res, { depth: null, colors: true });
      console.log("=================================");
      if (res?.success && Array.isArray(res.data)) {
        if (res.data.length !== entities.length) {
          console.log('=== "ici" === Sidebar.jsx === key: 705451 ===');
          console.dir("ici", { depth: null, colors: true });
          console.log("=================================");
          setEntities(res.data);
        }
      }
    };
    loadEntities();
  }, [isCRO]);

  const handleSignOut = () => {
    AuthController.logout("/");
  };

  const handleCreateStudy = () => {
    navigateTo("/create-study");
  };

  const handleNavClick = (linkName) => {
    setCurrentActive(linkName);
  };

  // Définition des liens de navigation directement dans le composant
  const navLinks = [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: (
        <div className="w-6 h-6 flex items-center justify-center">
          <img
            src="/icons/sidebar/Dashboard 1.svg"
            alt="Dashboard"
            className="w-5 h-5"
          />
        </div>
      ),
    },
    {
      name: "Settings",
      path: "/settings",
      icon: (
        <div className="w-6 h-6 flex items-center justify-center">
          <img
            src="/icons/sidebar/Setting 1.svg"
            alt="Settings"
            className="w-5 h-5"
          />
        </div>
      ),
    },
    {
      name: "Notifications",
      path: "/notifications",
      icon: (
        <div className="w-6 h-6 flex items-center justify-center">
          <img
            src="/icons/sidebar/Notification 1.svg"
            alt="Notifications"
            className="w-5 h-5"
          />
        </div>
      ),
      badge: unreadCount > 0 ? unreadCount.toString() : null,
    },
    {
      name: "Support",
      path: "/support",
      icon: (
        <div className="w-6 h-6 flex items-center justify-center">
          <img
            src="/icons/sidebar/Support 1.svg"
            alt="Support"
            className="w-5 h-5"
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col h-screen w-56 md:w-64 bg-white">
      {/* En-tête avec logo */}
      <div className="p-4 md:p-6 lg:p-8 flex justify-center">
        <img src="/img/Oshimed menu bar.png" alt="Logo" className="h-7" />
      </div>

      {/* Liens de navigation */}
      <nav className="flex-grow">
        <ul className="py-2 space-y-0.5">
          {navLinks.map((link) => {
            const isActive = currentActive === link.name;

            return (
              <li key={link.name}>
                <Link
                  to={link.path}
                  className={`flex items-center py-2 md:py-3 text-sm ${
                    isActive
                      ? "bg-gradient-to-r from-indigo-200 to-white text-indigo-600 font-medium"
                      : "text-gray-500 hover:bg-gray-100"
                  }`}
                  onClick={() => handleNavClick(link.name)}
                >
                  <span
                    className={`mr-2 ml-4 md:mr-3 md:ml-6 ${
                      isActive ? "text-indigo-600" : "text-gray-500"
                    }`}
                  >
                    {link.icon}
                  </span>
                  {link.name}
                  {link.badge && (
                    <span className="ml-8 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                      {link.badge}
                    </span>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {isCRO && entities.length > 0 && (
        <div className="px-6 mb-4 flex justify-center ">
          <select
            className="appearance-none w-[85%] border rounded-2xl px-1 py-2 text-sm bg-linkColor text-center text-white"
            value={STATE[CurrentEntityState.CURRENT_ENTITY_ID] || ""}
            onChange={(e) => {
              const id = e.target.value;
              const data = entities.find((it) => it.id === id) || null;
              State.setValue(CurrentEntityState.CURRENT_ENTITY_ID, id);
              State.setValue(CurrentEntityState.CURRENT_ENTITY_DATA, data);
            }}
          >
            <option value="" disabled>
              Select entity
            </option>
            {entities.map((ent) => (
              <option key={ent.id} value={ent.id}>
                {ent.entity_data?.contact?.entityName || ent.id}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="flex-grow"></div>

      {/* Actions en bas */}
      <div className="p-4 space-y-3">
        {/* Create new study button - only shown for CRO role */}
        {isCRO && (
          <div className="flex justify-center">
            <Button
              variant="createstudy"
              onClick={handleCreateStudy}
              className="w-[85%] py-1.5 text-sm"
            >
              Create new study
            </Button>
          </div>
        )}
        {/* User info and logout */}
        <div className="flex justify-center mb-2">
          <div className="bg-blue-200 w-[85%] rounded-xl py-1.5 flex items-center justify-between">
            <div className="flex items-center mx-auto">
              <div>
                <p className="text-sm mb-2 font-medium">
                  {STATE[CurrentEntityState.CURRENT_ENTITY_DATA]?.entity_data
                    ?.contact?.entityName || "No company selected"}
                </p>
                <button
                  onClick={handleSignOut}
                  className="text-xs text-gray-600 flex items-center gap-1 mx-auto"
                >
                  Sign out{" "}
                  <img
                    className="h-4 w-4"
                    alt="sign out"
                    src="/icons/study/Sign out.svg"
                  ></img>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
